const OHL = [
    { id: "0", value: "開盤價" },
    { id: "1", value: "最高價" },
    { id: "2", value: "最低價" },
    { id: "3", value: "股價" },    
];

export default OHL  